/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Survey_Vote_QuestionInputs */

const sv_page_survey_vote_question = /** @type {(inputs: Page_Survey_Vote_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Var den här sidan till hjälp?`)
};

const en_page_survey_vote_question = /** @type {(inputs: Page_Survey_Vote_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was this page helpful?`)
};

/**
* | output |
* | --- |
* | "Was this page helpful?" |
*
* @param {Page_Survey_Vote_QuestionInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const page_survey_vote_question = /** @type {((inputs?: Page_Survey_Vote_QuestionInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Survey_Vote_QuestionInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_page_survey_vote_question(inputs)
	return en_page_survey_vote_question(inputs)
});